import { render, staticRenderFns } from "./shopDecoration.vue?vue&type=template&id=790bb406"
import script from "./shopDecoration.vue?vue&type=script&lang=js"
export * from "./shopDecoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports